import { CodeableConcept } from "../types/codeableConcept";
import { Reference } from "../types/reference";
import { createCodeableConcept } from "../utils/DataUtils";

const createDefault = (
  medication: CodeableConcept & {
    info: { ingredient: { name: string; strength: string }[] };
  },
  encounter: Reference,
  patient: Reference,
  practitioner: Reference,
) => {
  return {
    medication,
    category: createCodeableConcept("community", "community", "community"),
    dispenseRequest: {
      initialFill: {},
    },
    dosageInstruction: [
      {
        text: "",
        doseAndRate: [{}],
        timing: {
          code: {
            coding: [null],
          },
        },
      },
    ],
    encounter: encounter,
    reasonCode: createCodeableConcept("community", "community", "community"),
    recorder: practitioner,
    status: "active",
    subject: patient,
    substitution: {
      allowed: false,
    },
  };
};

export const MedicationRequestManager = {
  createDefault,
};
